"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _audioUtils = _interopRequireDefault(require("../../util/audioUtils"));
var _clamp2 = _interopRequireDefault(require("lodash/clamp"));
Entry.AI_UTILIZE_BLOCK.audio = {
  name: 'audio',
  imageName: 'audio.svg',
  category: 'audio',
  sponsorText: 'Powered by {image}',
  sponsorImage: 'naverClova.png',
  sponsorOnImage: 'naverClovaOn.png',
  title: {
    ko: '음성 인식',
    en: 'Speech recognition',
    jp: 'オーディオ検出'
  },
  titleKey: 'template.voice_title_text',
  description: Lang.Msgs.ai_utilize_audio_description,
  descriptionKey: 'Msgs.ai_utilize_audio_description',
  isInitialized: false,
  init: function init() {
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _audioUtils["default"].initialize();
          case 1:
            Entry.AI_UTILIZE_BLOCK.audio.isInitialized = true;
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};
Entry.AI_UTILIZE_BLOCK.audio.getBlocks = function () {
  return {
    audio_title: {
      skeleton: 'basic_text',
      color: EntryStatic.colorSet.common.TRANSPARENT,
      params: [{
        type: 'Text',
        text: Lang.template.audio_title_text,
        color: EntryStatic.colorSet.common.TEXT,
        align: 'center'
      }],
      def: {
        type: 'audio_title'
      },
      "class": 'audio',
      isNotFor: ['audio'],
      events: {}
    },
    check_microphone: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [],
      events: {},
      def: {
        type: 'check_microphone'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'audio',
      isNotFor: ['audio'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var _t;
          return _regenerator["default"].wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                if (_audioUtils["default"].isInitialized) {
                  _context2.next = 1;
                  break;
                }
                _context2.next = 1;
                return _audioUtils["default"].initialize();
              case 1:
                return _context2.abrupt("return", _audioUtils["default"].audioInputList.length > 0);
              case 2:
                _context2.prev = 2;
                _t = _context2["catch"](0);
                return _context2.abrupt("return", false);
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 2]]);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_stt'
    },
    get_microphone_volume: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [],
      events: {},
      def: {
        type: 'get_microphone_volume'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'audio',
      isNotFor: ['audio'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          return _regenerator["default"].wrap(function (_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (_audioUtils["default"].isInitialized) {
                  _context3.next = 1;
                  break;
                }
                _context3.next = 1;
                return _audioUtils["default"].initialize();
              case 1:
                return _context3.abrupt("return", _audioUtils["default"].currentVolume);
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_stt'
    },
    speech_to_text_title: {
      skeleton: 'basic_text',
      color: EntryStatic.colorSet.common.TRANSPARENT,
      params: [{
        type: 'Text',
        text: Lang.template.voice_title_text,
        color: EntryStatic.colorSet.common.TEXT,
        align: 'center'
      }],
      def: {
        type: 'speech_to_text_title'
      },
      "class": 'stt',
      isNotFor: ['audio'],
      events: {}
    },
    speech_to_text_convert: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [{
        type: 'Dropdown',
        options: [[Lang.Blocks.korean_s, 'Kor'], [Lang.Blocks.english_s, 'Eng'], [Lang.Blocks.japan_s, 'Jpn']],
        value: 'Kor',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      }, {
        type: 'Indicator',
        img: 'block_icon/ai_utilize_icon.svg',
        size: 11
      }],
      events: {
        viewAdd: [function () {
          if (Entry.container.sttValue) {
            Entry.container.sttValue.setVisible(true);
          }
        }],
        viewDestroy: [function (block, notIncludeSelf) {
          if (Entry.container.sttValue) {
            Entry.container.sttValue.checkVisible(block, notIncludeSelf);
          }
        }]
      },
      def: {
        params: [null],
        type: 'speech_to_text_convert'
      },
      paramsKeyMap: {
        LANG: 0
      },
      "class": 'stt',
      isNotFor: ['audio'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
          var language, result, _t2;
          return _regenerator["default"].wrap(function (_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (_audioUtils["default"].isInitialized) {
                  _context4.next = 1;
                  break;
                }
                _context4.next = 1;
                return _audioUtils["default"].initialize();
              case 1:
                if (!_audioUtils["default"].isRecording) {
                  _context4.next = 2;
                  break;
                }
                return _context4.abrupt("return");
              case 2:
                _context4.prev = 2;
                language = script.getField('LANG', script);
                if (language === 'Kor') {
                  Entry.container.sttValue.setName("".concat(Lang.template.voice_title_text, ":").concat(Lang.Blocks.korean_s));
                } else if (language === 'Eng') {
                  Entry.container.sttValue.setName("".concat(Lang.template.voice_title_text, ":").concat(Lang.Blocks.english_s));
                } else if (language === 'Jpn') {
                  Entry.container.sttValue.setName("".concat(Lang.template.voice_title_text, ":").concat(Lang.Blocks.japan_s));
                }
                _audioUtils["default"].isRecording = true;
                Entry.container.enableSttValue();
                _context4.next = 3;
                return _audioUtils["default"].startRecord(60 * 1000, language);
              case 3:
                result = _context4.sent;
                Entry.dispatchEvent('audioRecordingDone');
                Entry.container.setSttValue(result || '-');
                _context4.next = 5;
                break;
              case 4:
                _context4.prev = 4;
                _t2 = _context4["catch"](2);
                Entry.container.setSttValue('-');
                throw _t2;
              case 5:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[2, 4]]);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_stt'
    },
    timed_speech_to_text_convert: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [{
        type: 'Block',
        accept: 'string',
        defaultType: 'number',
        value: '10'
      }, {
        type: 'Dropdown',
        options: [[Lang.Blocks.korean_s, 'Kor'], [Lang.Blocks.english_s, 'Eng'], [Lang.Blocks.japan_s, 'Jpn']],
        value: 'Kor',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      }, {
        type: 'Indicator',
        img: 'block_icon/ai_utilize_icon.svg',
        size: 11
      }],
      events: {
        viewAdd: [function () {
          if (Entry.container.sttValue) {
            Entry.container.sttValue.setVisible(true);
          }
        }],
        viewDestroy: [function (block, notIncludeSelf) {
          if (Entry.container.sttValue) {
            Entry.container.sttValue.checkVisible(block, notIncludeSelf);
          }
        }]
      },
      def: {
        params: [null],
        type: 'timed_speech_to_text_convert'
      },
      paramsKeyMap: {
        TIME: 0,
        LANG: 1
      },
      "class": 'stt',
      isNotFor: ['audio'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
          var time, language, result, _t3;
          return _regenerator["default"].wrap(function (_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (_audioUtils["default"].isInitialized) {
                  _context5.next = 1;
                  break;
                }
                _context5.next = 1;
                return _audioUtils["default"].initialize();
              case 1:
                if (!_audioUtils["default"].isRecording) {
                  _context5.next = 2;
                  break;
                }
                return _context5.abrupt("return");
              case 2:
                _context5.prev = 2;
                time = (0, _clamp2["default"])(script.getNumberValue('TIME'), 1, 60);
                language = script.getField('LANG', script);
                if (language === 'Kor') {
                  Entry.container.sttValue.setName("".concat(Lang.template.voice_title_text, ":").concat(Lang.Blocks.korean_s));
                } else if (language === 'Eng') {
                  Entry.container.sttValue.setName("".concat(Lang.template.voice_title_text, ":").concat(Lang.Blocks.english_s));
                } else if (language === 'Jpn') {
                  Entry.container.sttValue.setName("".concat(Lang.template.voice_title_text, ":").concat(Lang.Blocks.japan_s));
                }
                _audioUtils["default"].isRecording = true;
                Entry.container.enableSttValue();
                _context5.next = 3;
                return _audioUtils["default"].startTimedRecord(time * 1000, language);
              case 3:
                result = _context5.sent;
                Entry.dispatchEvent('audioRecordingDone');
                Entry.container.setSttValue(result || '-');
                _context5.next = 5;
                break;
              case 4:
                _context5.prev = 4;
                _t3 = _context5["catch"](2);
                Entry.container.setSttValue('-');
                throw _t3;
              case 5:
              case "end":
                return _context5.stop();
            }
          }, _callee5, null, [[2, 4]]);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_stt'
    },
    set_visible_speech_to_text: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [{
        type: 'Dropdown',
        options: [[Lang.Blocks.CALC_timer_visible_show, 'SHOW'], [Lang.Blocks.CALC_timer_visible_hide, 'HIDE']],
        value: 'SHOW',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      }, {
        type: 'Indicator',
        img: 'block_icon/ai_utilize_icon.svg',
        size: 11
      }],
      events: {
        viewAdd: [function () {
          if (Entry.container.sttValue) {
            Entry.container.sttValue.setVisible(true);
          }
        }],
        viewDestroy: [function (block, notIncludeSelf) {
          if (Entry.container.sttValue) {
            Entry.container.sttValue.checkVisible(block, notIncludeSelf);
          }
        }]
      },
      def: {
        type: 'set_visible_speech_to_text'
      },
      paramsKeyMap: {
        ACTION: 0
      },
      "class": 'stt',
      isNotFor: ['audio'],
      func: function func(sprite, script) {
        var action = script.getField('ACTION');
        var sttValue = Entry.container.sttValue;
        if (!sttValue) {
          return script.callReturn();
        } else if (action === 'SHOW') {
          sttValue.setVisible(true);
        } else {
          sttValue.setVisible(false);
        }
        return script.callReturn();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_stt'
    },
    speech_to_text_get_value: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [],
      events: {
        viewAdd: [function () {
          if (Entry.container.sttValue) {
            Entry.container.sttValue.setVisible(true);
          }
        }],
        viewDestroy: [function (block, notIncludeSelf) {
          if (Entry.container.sttValue) {
            Entry.container.sttValue.checkVisible(block, notIncludeSelf);
          }
        }]
      },
      def: {
        type: 'speech_to_text_get_value'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'stt',
      isNotFor: ['audio'],
      func: function func(sprite, script) {
        return Entry.container.getSttValue();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_stt'
    }
  };
};